import React from "react";

export const ButtonSearchComponent = ({ filter }) => {
  return (
    <div className="buttonSearchComponent">
      <button onClick={filter}>Buscar</button>
    </div>
  );
};
